import { ModalBody, ModalFooter, ModalButton, Paragraph2 } from '@shared/components';
import { useModalContext } from '@shared/hocs/modal-context';
import { useThemeContext } from '@shared/hooks';

export const DeleteUsersModal = (props: any) => {
  const { data } = props;
  const theme = useThemeContext();
  const modalContext = useModalContext();

  const handleConfirm = () => {
    modalContext.setPayload(true);
    modalContext.close();
  };

  const handleCancel = () => {
    modalContext.setPayload(false);
    modalContext.close();
  };

  return (
    <>
      <ModalBody>
        <Paragraph2>
          {data.length === 1 && (
            <>
              Are you sure you want to delete <b>{`${data[0].fullName}`}</b>?
            </>
          )}
          {data.length > 1 && (
            <>
              Are you sure you want to delete <b>{data.length} users</b>?
            </>
          )}
          <br />
          They will be immediately signed out and their account permanently deleted.
        </Paragraph2>
      </ModalBody>
      <ModalFooter>
        <ModalButton style={{ color: theme.colors.mono800 }} kind="minimal" onClick={handleCancel}>
          Cancel
        </ModalButton>
        <ModalButton style={{ backgroundColor: theme.colors.negative }} onClick={handleConfirm}>
          Yes, delete
        </ModalButton>
      </ModalFooter>
    </>
  );
};
